import { Link } from "react-router-dom";

export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <rect x="8" y="8" width="32" height="32" rx="7" transform="rotate(45 24 24)" stroke="#D4AF37" strokeWidth="2" />
    <path d="M13 31 L19.5 16 L26 31" stroke="#F1D27A" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.8 25.5 H23.2" stroke="#F1D27A" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M28 17 H38 M33 17 V31" stroke="#D4AF37" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="brand-logo" className="group flex items-center gap-3" aria-label="AT Digital — home">
    <LogoMark className="h-9 w-9 transition-transform duration-500 group-hover:rotate-45" />
    <span className="font-display text-lg font-extrabold tracking-[0.16em]">
      <span className="text-gold">AT</span>{" "}
      <span className="text-white">DIGITAL</span>
    </span>
  </Link>
);
